import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'decodeUrl',
  pure: true
})
export class DecodeUrlPipe implements PipeTransform {
  transform(url: string): string {
    if (!url) {
      return '';
    }

    return decodeURIComponent(url);
  }
}
